<template>
    <v-card outlined>
        <v-data-table
            dense
            fixed-body
            fixed-header
            :headers             = "header_table"
            :items               = "render_list"
            class                = "elevation-5"
            :loading             = "loading"
            item-key             = "index"
            :height              = "layout_height + 'px'"
            :loading-text        = "$ml.get('loading')"
            v-model              = "rules_selecteds"
            :options.sync        = "options"
            :server-items-length = "total"
            :footer-props        = "{
                showFirstLastPage   : true,
                itemsPerPageOptions : [total], // 15, 30
                showCurrentPage     : true,
                itemsPerPageText    : ''
            }"
            
        >
            <!-- show-select -->
            <!-- selectable-key         = "id" -->
        <!-- Loading... Please wait -->
            <!-- rowsPerPageText: [30] -->
            <!-- <template v-slot:header.data-table-select="{ on , props }">
                <span>
                <v-simple-checkbox
                    color   = "purple"
                    v-bind  = "props"
                    v-on    = "on"
                    :ripple = "false"
                />
                    
                {{$ml.get('active')}}               
                </span>
            </template> -->

            <template 
                v-for   = "head of header_table"
                v-slot:[`header.${head.value}`]
            >
                {{ $ml.get(head.text) }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn-toggle mandatory>

                    <v-btn
                        x-small
                        color  = "primary"
                        @click = "actions('edit', item)"
                        v-show = "show.edit_rule"
                    >
                        <v-icon x-small>mdi-pencil</v-icon>
                    </v-btn>    
                    <v-btn
                        x-small
                        color       = "error"
                        @click.stop = "actions('confirm_delete', item)"
                        class       = "mx-1"
                        v-show      = "show.delete_rule"
                    >
                        <v-icon x-small>mdi-delete</v-icon>
                    </v-btn>
                </v-btn-toggle>                         
            </template>

            <template
                v-slot:item.entity="{ item }"
            >
                <v-chip 
                    text
                    x-small 
                    color   = "primary"
                    v-if    = "item && item.entity"
                >
                    {{ actions('render_entity', item, 'userName') }}
                </v-chip>
            </template>
            <template
                v-slot:item.idList="{ item }"
            >
                <v-chip 
                    text
                    x-small 
                    color   = "primary"     
                    class   = "text-uppercase ma-1"         
                >
                    {{ actions('render_idList', item) }}
                </v-chip>
            </template>

            <template v-slot:top>
                <v-toolbar
                    flat
                    dense
                    height = "30"
                    class  = ""
                >
                <!-- grey lighten-1 -->
                    <!-- <v-toolbar-title> -->
                        <v-tooltip
                            bottom
                        >   
                            <template v-slot:activator = "{ on , attrs}">
                                
                                <v-btn
                                    dark
                                    x-small
                                    :color = "active_rules.color"
                                    class  = "mx-2"
                                    v-bind = "attrs"
                                    v-on   = "on"
                                    v-show = "show.active_rules"
                                    @click = "actions('active_rules', !active_rules.active)"
                                >
                                    <!-- {{ v-text = "'New'" }} -->

                                    <v-icon
                                        x-small
                                        class = "mr-1"
                                    >
                                        mdi-info
                                    </v-icon>
                                    <span>
                                        {{ $ml.get(active_rules.text) }}
                                    </span>
                                </v-btn>    
                            </template>
                            <span>
                                {{ $ml.get(active_rules.tooltip) }}
                            </span>
                        </v-tooltip>
                        <v-text-field 
                            dense
                            outlined
                            v-model      = "search" 
                            :label       = "$ml.get('search')" 
                            class        = "mx-4 pt-1 " 
                            append-icon  = "mdi-magnify" hide-details
                            @input       = "v => { search = v.toUpperCase() }"
                            @click       = "keyboard_is_active()"
                            @keyup.enter = "get_search(search)"
                            v-show       = "false"
                            
                        ></v-text-field>
                        <input 
                            dark
                            type   = "" 
                            name   = ""
                            @input = "onInputChange"
                            :value = "input"
                            class  = "input"
                            v-show = "false"
                        >
                            
                        <v-bottom-sheet 
                            dark
                            inset 
                            v-model = "sheet" 
                        >                       
                            <v-sheet 
                                height = "300px" 
                                class  = "pa-1"
                            >
                                <SimpleKeyboard 
                                    @onChange   = "onChange" 
                                    @onKeyPress = "onKeyPress" 
                                    :input      = "search" 
                                    :theme      = "theme"
                                />
                            </v-sheet>
                        </v-bottom-sheet>  
                    <!-- </v-toolbar-title> -->
                    <!-- <v-spacer></v-spacer> -->
                    <!-- <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider> -->
                    
                    <v-spacer></v-spacer>
                    <v-dialog 
                        v-model   = "dialog"
                        max-width = "500px"
                    >
                        
                        <template v-slot:activator = "{ on, attrs }">
                            <v-btn
                                dark
                                x-small
                                color  = "primary"
                                class  = "mx-2"
                                v-bind = "attrs"
                                v-on   = "on"
                                v-show = "show.add_rule"
                                
                            >
                                <!-- {{ v-text = "'New'" }} -->

                                <v-icon
                                    x-small
                                    class = "mr-1"
                                >
                                    mdi-plus
                                </v-icon>
                                <span>
                                    {{ $ml.get('new') }}
                                </span>
                            </v-btn>    
                        </template>
                        <v-card outlined>
                            <v-card-title
                                class = "primary pa-1 body-2"
                            >   
                            <!-- chart-box-plus-outline -->
                                <v-icon
                                    x-small 
                                    class = "mx-1"
                                >
                                    mdi-data-matrix-plus
                                </v-icon>
                                <span>
                                    {{ $ml.get(title) }}
                                </span>
                                <v-spacer></v-spacer>
                                <v-btn
                                    x-small
                                    class = "error"
                                    icon
                                    @click = "dialog = false"
                                >
                                    
                                    <v-icon
                                        x-small
                                        color="white"
                                    >
                                        mdi-close
                                    </v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                <template
                                    v-for = "(item_field,  idx_field) of fieds_table"

                                >
                                    <v-text-field
                                        dense
                                        outlined
                                        hide-details
                                        :key         = "idx_field"
                                        v-if         = "item_field.type == 'text'"
                                        v-show       = "item_field.activator.includes(info.analytic)"
                                        class        = "mx-2 my-2"
                                        :type        = "item_field.type"
                                        :label       = "$ml.get(item_field.text)"
                                        v-model      = "info[item_field.key]"
                                        :placeholder = "item_field.placeholder"
                                        :value       = "render_value(item_field)"

                                    >
                                        <v-icon
                                            v-if   = "item_field.key == 'timeout' || item_field.key == 'alertTime'"
                                            small
                                            slot   = "append"
                                            color  = "primary"
                                        >
                                            mdi-timer
                                        </v-icon>
                                        <v-icon
                                            v-if   =  "item_field.key == 'probability' "
                                            small
                                            slot   = "append"
                                            color  = "primary"
                                        >
                                            mdi-percent
                                        </v-icon>
                                    </v-text-field>
                                    <v-text-field
                                        dense
                                        outlined
                                        hide-details
                                        :key         = "idx_field"
                                        v-if         = "item_field.type == 'number'"
                                        v-show       = "item_field.activator.includes(info.analytic)"
                                        class        = "mx-2 my-2"
                                        :type        = "item_field.type"
                                        :label       = "$ml.get(item_field.text)"
                                        v-model.number   = "info[item_field.key]"
                                        :placeholder = "item_field.placeholder"
                                        :value       = "render_value(item_field)"
                                        :suffix      = "item_field.suffix"

                                    >
                                        <v-icon
                                            v-if   = "item_field.key == 'timeout' || item_field.key == 'alertTime'"
                                            small
                                            slot   = "append"
                                            color  = "primary"
                                        >
                                            mdi-timer
                                        </v-icon>
                                        <v-icon
                                            v-if   =  "item_field.key == 'probability' "
                                            small
                                            slot   = "append"
                                            color  = "primary"
                                        >
                                            mdi-percent
                                        </v-icon>
                                    </v-text-field>

                                    <v-select
                                        v-if="item_field.key === 'idList'"
                                        :key="idx_field + '_select'"
                                        dense
                                        outlined
                                        hide-details
                                        clearable
                                        v-show="item_field.activator.includes(info.analytic) || item_field.key == 'analytic'"
                                        :label="$ml.get(item_field.text)"
                                        v-model="info[item_field.key]"
                                        :items="sortedList(filtered_lists[item_field.list] || [], getListFilter())"
                                        :item-value="item_field.value_list"
                                        :item-text="item_field.text_list"
                                        class="mx-2 my-2"
                                        :value="render_value(item_field)"
                                        :disabled="(item_field.key == 'analytic' && info.id ) || disableds[item_field.key] ? true : false"
                                        @change="actions(item_field.action, info[item_field.key])"
                                        :multiple="item_field.isMultiple"
                                    >
                                        <template v-slot:prepend-item v-if = "item_field.filter">
                                            <v-list-item v-show = "item_field.filter">
                                                <v-list-item-content>
                                                    <v-text-field 
                                                        v-model      = "info_search[item_field.key]" 
                                                        :label       = "$ml.get('search')" 
                                                        class        = "mx-1 pt-0" 
                                                        append-icon  = "mdi-magnify" 
                                                        @input       = "v => { filter_search(v, item_field.list, item_field.text_list) }"
                                                        hide-details
                                                        outlined
                                                        dense                       
                                                    ></v-text-field>
                                                </v-list-item-content>
                                              </v-list-item>
                                              <v-divider class="mt-1"></v-divider>
                                            </template>
                                    </v-select>

                                    <v-select
                                        v-else-if="item_field.type === 'select'"
                                        :key="idx_field + '_select'"
                                        dense
                                        outlined
                                        hide-details
                                        clearable
                                        v-show="item_field.activator.includes(info.analytic) || item_field.key == 'analytic'"
                                        :label="$ml.get(item_field.text)"
                                        v-model="info[item_field.key]"
                                        :items="Array.isArray(item_field.list) ? item_field.list : (filtered_lists[item_field.list] || [])"
                                        :item-value="item_field.value_list"
                                        :item-text="item_field.text_list"
                                        class="mx-2 my-2"
                                        :value="render_value(item_field)"
                                        :disabled="(item_field.key == 'analytic' && info.id ) || disableds[item_field.key] ? true : false"
                                        @change="actions(item_field.action, info[item_field.key])"
                                        :multiple="item_field.isMultiple"
                                    >
                                        <template v-slot:prepend-item v-if = "item_field.filter">
                                            <v-list-item v-show = "item_field.filter">
                                                <v-list-item-content>
                                                    <v-text-field 
                                                        v-model      = "info_search[item_field.key]" 
                                                        :label       = "$ml.get('search')" 
                                                        class        = "mx-1 pt-0" 
                                                        append-icon  = "mdi-magnify" 
                                                        @input       = "v => { filter_search(v, item_field.list, item_field.text_list) }"
                                                        hide-details
                                                        outlined
                                                        dense                       
                                                    ></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mt-1"></v-divider>
                                        </template>
                                    </v-select>

                                    <v-card
                                        outlined
                                        v-if    = "item_field.type == 'switch'"
                                        v-show  = "item_field.activator.includes(info.analytic) || item_field.key == 'state'"
                                        class   = "pa-0"                                            
                                    >
                                        
                                        <v-switch
                                            dense 
                                            hide-details
                                            class           = "pa-0 my-2 ml-2"
                                            :label          = "$ml.get(item_field.text)"
                                            v-model         = "info[item_field.key]"    
                                        ></v-switch>
                                            <!-- false-value -->
                                        
                                    </v-card>
                                    


                                </template>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    x-small
                                    color  = "primary"                                  
                                    @click = "actions(action_dialog)"
                                >
                                    {{  $ml.get(action_dialog) }}
                                </v-btn>
                                <v-btn
                                    x-small
                                    color  = "error"
                                    @click = "dialog = false"
                                >
                                    {{ $ml.get('close') }}
                                </v-btn>

                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>           
                
            </template>
            
        </v-data-table>
    </v-card>
</template>
<script>
    import EventBus from '@/event-bus'
    import MenuAutocompleteTrained from "@/components/face/MenuAutocompleteTrained.vue"
    import listTecnicalsCode from "@/components/alarms/js/listTecnicalsCode.js"
    export default{
        name        : 'rules_alarms',
        props       : ['info_to_component'],
        components : {MenuAutocompleteTrained},
        data        : (vm) => ({
            info            : {             
                analytic : '',
                state    : true,
            },
            info_id         : null, 
            info_item       : null,
            title           : 'new',
            rules_selecteds : [],
            header_table    : [
                // { text: vm.$ml.get('name'), value: 'name' },
                // { text: 'Tag', value: 'tag' },
                { text : 'analytic',    value : 'analytic' },
                { text : 'status',      value : 'state' },      
                { text : 'tag',         value : 'tag' },
                { text : 'alert_time',  value : 'alertime' },
                { text : 'probability', value : 'prob' },
                { text : 'tag_count',   value : 'countag' },
                { text : 'side',        value : 'side' },
                { text : 'way',         value : 'way' },
                { text : 'list_id',     value : 'idList' },
                { text : 'entity',      value : 'entity' },
                { text : 'access',      value : 'access' },
                { text : 'speed',       value : 'speed' },
                { text : 'direction',   value : 'direction' },

                // { text : 'active',       value : 'state' },
                { text: 'actions',      value: 'actions' },
            ],
            fieds_table  : [
                { 
                    text : "analytic",
                    key  : "analytic",
                    type : "select",
                    activator   : ['analytic'],
                    action      : "refresh_disabled",
                    list : [
                        /*'person',
                        'gun',*/
                        'motion',
                        'object',
                        'lpr',
                        // 'anomalies'
                        'face',                     
                        // 'anomalies',
                        'actions',
                        'parking',
                        'technical',                       
                        'Face-Access-Terminal',

                    ]
                },
                { 
                    text        : "tag",
                    key         : "tag",
                    type        : "select",
                    isMultiple  : true,
                    activator   : ['object'],
                    list        : [
                        'person',
                        'gun',
                        'lpr',
                        'car',
                        'truck',
                        'laptop',
                        'motorbike', // motorcycle
                        'bus',
                        'knife',            
                        'aeroplane',
                        'fire',
                        'helmet',
                        'no_helmet',
                        'box',          
                        "Hardhat",
                        "Mask",
                        "NO-Hardhat",
                        "NO-Mask",
                        "NO-Safety",
                        "Ves",
                        "Person",
                        "Safety",
                        "Cone",
                        "Safety",
                        "Vest",
                        "machinery",
                        "vehicle",
                        "bag",
                        "jug",                      
                        "basket",
                        "tray",
                        "box",
                        "carrot"
                    ]
                },
                { 
                    text        : "tag",
                    key         : "tag",
                    type        : "select",
                    activator   : [ 'actions'],
                    list        : [
                        'hands_up',
                        'walking',
                        'fighting',
                        'calling',
                        'falling',
                        'sitting',
                        'standing',                     
                    ]
                },
                { 
                    key         : 'side',
                    text        : 'side', // alertTime
                    type        : 'select',
                    activator   : ['object'],
                    list        : [ "-1", "0", "1", "2", "3"],
                    value_def   : "-1",
                },
                { 
                    key         : 'way',
                    text        : 'way', // alertTime
                    type        : 'select',
                    activator   : ['object'],
                    list        : [ 'ALL', 'IN', 'OUT'],
                    value_def   : 'ALL',
                },
                { 
                    key         : 'alertime',
                    text        : 'minimum_time', // alertTime
                    type        : 'number',
                    activator   : ['object'],
                    value_def   : 0.2,
                },
                { 
                    key         : 'prob',
                    text        : 'probability',
                    type        : 'number',
                    activator   : ['object', 'actions', 'face','Face-Access-Terminal'],
                    value_def   : 40,
                },
                { 
                    key         : 'countag',
                    text        : 'capacity', // countTag
                    type        : 'number',
                    activator   : ['object'],
                    value_def   : 1,
                },
                {
                    key         : 'idList',
                    text        : 'list',
                    type        : 'select',
                    check_list  : ['lpr', 'parking', 'face','Face-Access-Terminal'],
                    value_list  : 'id',
                    text_list   : 'name',
                    activator   : ['lpr', 'parking', 'face','Face-Access-Terminal'],
                    list        : 'list_multi', // list_lprs
                    action      : "disable_entity", // in change
                },
                {
                    key         : 'direction',
                    text        : 'direction',
                    type        : 'select',
                    activator   : ['lpr', 'parking'],
                    list        : ['up', 'down', 'stationary', 'all'],
                    value_def   : 'all',
                },
                {
                    key : "status",
                    text : "technical_status",
                    type        : 'select',
                    value_list  : 'code', // key
                    text_list   : 'name',
                    list        : 'listStatusTecnicals',
                    activator   : [ 'technical' ],

                },
                {
                    key : "speed",
                    text : "speed",
                    type : "number",
                    activator   : ['object'],
                    placeholder : "## ",
                    value_def   : -1,
                    suffix : "km/h"
                },
                /*{
                    key         : 'idList',
                    text        : 'list',
                    type        : 'select',
                    value_list  : 'id',
                    text_list   : 'name',
                    activator   : ['parking'],
                    list        : 'list_parking',
                },*/
                {
                    key         : 'entity',
                    text        : 'entity',
                    type        : 'select',
                    filter      : true,
                    value_list  : "userId", //'entity', // faceUUID
                    text_list   : 'userName', // entity
                    activator   : [ 'face','Face-Access-Terminal' ],
                    list        : 'list_entity',
                    action      : "disable_list", // in change
                },
                {
                    key         : 'access',
                    text        : 'access',
                    type        : 'switch',
                    activator   : [  ], // 'face'
                    default_false : false,
                },  
                {
                    key         : 'active',
                    text        : 'active',
                    type        : 'switch',
                    activator   : [  ], // 'face'
                    default_false : true,
                },              
                {               
                    key         : 'state',
                    text        : 'status',
                    type        : 'switch',
                    activator   : ['all'],
                },


                /*{ 
                    text : vm.$ml.get('name'),
                    key  : "name",
                    type : "text",
                },
                { 
                    text : "terms",
                    placeholder: "Select number to activate alarm",
                    key  : "terms",
                    type : "number",
                }
                */
            ],
            options          : { itemsPerPage: 30 },
            total            : 1,
            layout_height    : 200,
            list             : [],
            loading          : false,
            search           : null,
            input            : '',
            theme            : 'hg-theme-default myTheme1', // myTheme1
            sheet            : false,
            is_open_modal    : false,
            dialog           : false,
            list_entity      : [],
            header_analytics : ['state', 'analytic'], //check the head  in header table 
            action_dialog    : 'save',      
            info_alarm       : null,
            id_notification  : 'alarms_rule',
            info_search      : {}, 
            lists            : {
                list_entity : [],
                list_multi  : [],
            },          
            list_multi       : [],
            listStatusTecnicals :  listTecnicalsCode,
            // [
            //  { key : "-1", name : vm.$ml.get("initializing"), },
            //  { key : "0", name : vm.$ml.get("online"), },
            //  { key : "2", name : vm.$ml.get("offline"), },
            //  { key : "3", name : vm.$ml.get("restarting"), },

            // ],
            bus              : {},
            list_default_falses : ["access","active"],
            show                : {
                add_rule    : true,
                edit_rule   : true,
                delete_rule : true,
                active_rules : false,
            },
            disableds       : {
                entity : false,
                listId : false,
            },
            active_rules    : {
                text        : "follow_all_rules", // comply any rules
                color       : "success",
                tooltip     : "description_follow_all_rules",
                active      : true,
                

            }

        }), // data

        created(){
            console.log("alarm_rules created - info_to_component:", this.info_to_component);
            if (this.info_to_component){
                console.log("Calling render_info and get_listing");
                this.render_info(this.info_to_component);
                // this.get_list_trained();
                this.get_listing();
            } else {
                console.log("No info_to_component, calling get_listing anyway");
                this.get_listing();
            }
            let modul = this.$store.getters["auth/permission"](this.$route.name || "smart_event", "", "smart_event")
            if (modul) {
                if (!modul.can_edit) {
                    this.show.edit_rule = false;
                }
                if (!modul.can_add) {
                    this.show.add_rule = false;
                }
                if (!modul.can_delete) {                    
                    this.show.delete_rule = false;
                }

            }
        }, // created

        watch:{
            options: {
                handler(){
                    // this.get_list();
                }, deep: true,
            }, // options

            dialog: function(val){
                if (!val) {
                    this.info = {
                        analytic : '',
                        state    : true,
                    };
                    this.action_dialog  = 'save';
                    this.title          = 'new';
                } else {
                    // Modal se está abriendo
                    console.log("Modal opening - list_multi:", this.list_multi);
                    console.log("Modal opening - lists.list_multi:", this.lists.list_multi);
                    console.log("Modal opening - render_list_multi:", this.render_list_multi);
                }
            }, // dialog

            info_to_component: function(val){
                if (val && val.default && val.default.rules) {
                    this.render_info(val)
                }
            },

        }, // watch

        methods:{
            actions(act, item, opt){
                /*console.log("action : ", act,
                    " item : ", item,
                    " opt : ", opt,
                    this.disableds);*/
                if (act == 'save' || act == 'update') {
                    // console.log(act, " ALARMS")
                    this.save(act);
                }
                if (act == 'edit') {
                    this.title          = 'edit';
                    this.action_dialog  = "update";
                    this.info           = {...item};
                    if (item && item.tag &&  typeof item.tag == 'string' && item.analytic == 'object' ) {
                        this.info.tag           = item.tag.split(",")
                    }
                    console.log(this.info ," *************EDIT")
                    this.info_id        = this.list.indexOf(item);
                    this.dialog         = true;
                }
                let temp_bus = 'notifications_modal' + this.id_notification;
                if (act == 'confirm_delete') {
                    this.info_item = item;
                    EventBus.$emit('notifications_modal', {
                        type: act,
                        ID: this.id_notification, 
                    });
                    EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
                        if (action){
                            this.actions('delete');
                        }
                    });
                }
                if (act == 'delete'){
                    this.delete();
                    EventBus.$off(temp_bus, this.bus[temp_bus]);
                }else if (act == "render_entity") {
                    let idx = this.list_entity.findIndex( x => (x && x.userId == item.entity));
                    // console.log("FINDED entity : ", idx)
                    if (idx >= 0) {
                        return this.list_entity[idx][opt] || this.list_entity[idx] ;
                    }
                    return this.$ml.get("n_a")
                }else 
                if( act == "disable_entity"){
                    if (item) {
                        this.disableds.entity = true;
                    }else{
                        this.disableds.entity = false;
                    }

                }else if (act == "disable_list") {
                    if (item) {
                        this.disableds.listId = true;
                    }else{
                        this.disableds.listId = false;
                    }
                }else if (act == "refresh_disabled") {
                    this.disableds = {
                        entity : false,
                        listId : false,
                    };
                }else if (act == "render_idList") {
                    if (item && item.analytic && item.idList && this.lists) {

                        let idx  = -1; 
                        let list = [];
                            list = this.render_list_multi;                          
                        /*if (["lpr", "parking"].includes(item.analytic)) {
                        }else if (item.analytic == "face") {
                            list = this.lists.list_entity;
                        }*/
                        if (list && list.length > 0) {

                            idx = list.findIndex( x => (x && x.id == item.idList));                                             
                            if (idx >= 0) {
                                return list[idx].name;
                            }                           
                        }
                    }
                    return this.$ml.get("n_a")
                }else if (act == "active_rules") {                                          
                    this.active_rules.active = item;
                    if (this.active_rules.active) {
                        this.active_rules.tooltip   = "description_follow_all_rules";
                        this.active_rules.color     = "success";
                        this.active_rules.text      = "follow_all_rules";
                    }else{                      
                        this.active_rules.tooltip   = "description_comply_any_rules";
                        this.active_rules.color     = "primary";
                        this.active_rules.text      = "comply_with_any_rule";
                    }
                    this.$emit("update_active_rule", item);
                }
            }, // actions

            render_info(item){
                // console.log(item, "INFO ALARMS" );
                this.info_alarm = item && item.default ? item.default : item;
                if (this.list && this.list.length === 0){
                // console.log("RENDER ITEM RULES ")
                    if (item && item.default && item.default.rules && item.default.rules.length > 0){
                        this.list       = item.default.rules
                        this.total      = this.list && this.list.length == 1 ?  1 : this.list.length - 1;
                    }

                    // render  header table 
                    /*let temp_table    = this.$Helper.get_local('header_rules_alarm');
                    if (temp_table){
                        console.log("HEADER TABLE ******************", temp_table)
                        this.header_table = temp_table;

                    }*/
                }
            }, // render info

            render_listed(list, check = false) {

                if (typeof list == 'string') {
                    // console.log("LIST ", this[list])
                    if (check && check.includes(this.info.analytic)) {
                        // console.log("LIST render ", list, check, this[list])

                        return this[list].filter(x => ( x && x.type == this.info.analytic));
                    }
                    // console.log("CHECK list ", list , this[list])
                    return this[list];
                }else{              
                    if (list && list.length > 0) {
                        return list;
                    }
                }
            }, // render lited

            get_list(){
                const { itemsPerPage, page } = this.options;
                let pg = 1, sw = 0;

                this.loading = true;


                if ( itemsPerPage == 15 ) {
                    if (page % 2 == 0) {
                        pg = (page/2);
                        sw = 2;
                    }else{
                        pg = parseInt(page/2)+1;
                        sw = 1;
                    }
                }else{
                    pg = page
                }
                const api = this.$URL + '/api/v1/alarm/?page='+pg;
                
                this.$axios.get(api).then( res => {
                    // console.log(res, 'Get list');
                    let items = res.data.rows;

                    this.total = parseInt(res.data.count);
                    
                    if (itemsPerPage <= 15) {
                        items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
                    }
                    
                    this.list = items;
                    this.loading = false;

                }).catch( er => {
                    console.log(er, 'Error get list');
                    this.loading = false;
                    if (er && er.message == 'Network Error') {
                        EventBus.$emit('notifications_modal', {
                            type : 'error',
                            message : er.message 

                        });
                    }
                    
                    this.list = this.$Helper.get_local('rule_alarm');
                    if (this.list && this.list.length > 0){
                        this.total = this.list.length;
                    }
                    // this.get_local();
                })
            }, // get list

            save(opt){
                const info_table  = { ...this.info };
                let list_temp     = this.list; 
                let msg           = 'saved';    
                let url           = this.$URL + '/api/v1/alarm/';
				let list_analytic = {
					object  : 'rule_obj',
					motion  : 'motion',
					lpr     : 'rule_lpr',
					face    : 'rule_face',
					'Face-Access-Terminal' : 'rule_face',
					actions : 'rule_actions',
					parking : "rule_lpr",
					technical : "rule_tecnical",
				}                       

                // roi
                // schedule
                // device
                // action
                let info_up = this.info_format(info_table);
                if (info_up && info_up.tag && info_up.tag.length > 0 && info_up.analytic == 'object') {
                    info_up.tag = info_up.tag.join(",");
                }
                if (info_table && info_table.id) {
                    info_up.id = info_table.id;
                }
                // console.log(this.info_alarm, this.info, " info update")
                if (this.title == 'new') { // save

                    if (this.info_alarm && this.info_alarm.id){                     
                        url = url + list_analytic[info_table.analytic];
                        // if (info_table.analytic == 'motion'){                            
                            info_up.alarmId = this.info_alarm.id; 
                        // }
                        // console.log("INFO UP : ", info_up )
						if (['lpr', 'face', 'Face-Access-Terminal'].includes(info_table.analytic)) {
                            let check_list_ent = true;
                            // console.log("CHECK LIST UP : ", info_up)
                            if (info_up.idList >= 0  && info_table.analytic == 'lpr') {
                                check_list_ent = false;
                            }
						if ((info_up.entity || info_up.idList >= 0 ) && ['face', 'Face-Access-Terminal'].includes(info_table.analytic)) {
							check_list_ent = false;
						}
                            if (check_list_ent) {

                                EventBus.$emit('notifications_modal', {
                                    type    : 'warning',
                                    message : this.$ml.get('require_sel_list'),
                                });
                                return false;
                            }
                        }

                        this.$axios.post(url, info_up).then( res => {
                            if (res.data && res.data.id){
                                info_up.id = res.data.id;
                            }                   
                            // this.disableds = {};                                 
                            this.update('saved', info_up, list_temp);
                        }).catch( er => {
                            
                            console.log("Error create", this.id_notification, er);
                            let err = er && er.message ? er.message : er;
                            EventBus.$emit('notifications_modal', {
                                type    : 'error',
                                message : 'Error create rule' + err,
                            });

                        })
                    }else{
                        this.update('saved', info_up, list_temp);
                        // this.disableds = {};

                    }
                    
                    


                }else{ // update
                    if (this.info_alarm && this.info_alarm.id ){
                        url = url  + list_analytic[info_table.analytic] + '/' + info_table.id;
                        // info_up.tag = 'Hands -up'
                        this.$axios.put(url, info_up).then( res => {
                            // this.disableds = {};
                            this.update('updated', info_up, list_temp);
                        }).catch( er => {                           
                            console.log("Error update", this.id_notification, er);
                            let err = er && er.message ? er.message : er;
                            EventBus.$emit('notifications_modal', {
                            type    : 'error',
                            message : 'Error update rule' + err,
                        });
                        })
                    }else{
                        this.update('updated', info_up, list_temp);
                        
                    }
                }
                console.log ( msg, "ALARMS ")
                
                
                
                
            }, // save

            update(act, info_up, list_temp){
                let msg = act
                if (act == 'updated'){
                    this.title = 'new';
                    this.list.splice(this.info_id, 1, info_up); // list_temp[] = 
                }else{
                    list_temp.push(info_up);
                    this.total++;
                }           
                this.$Helper.set_local('rule_alarm', this.list)
                    this.$emit('info_component', {
                        act     : 'render_compt',
                        opt     : 'rules',
                        value   : list_temp,
                    })
                    /*EventBus.$emit('notifications_modal', {
                        type: msg,                      
                    })*/
                    this.list = list_temp;
                    this.dialog = false;
            }, // update

            delete(){
                let url           = this.$URL + '/api/v1/alarm/';
			let list_analytic = {
					object  : 'rule_obj',
					motion  : 'motion',
					lpr     : 'rule_lpr',
					face    : 'rule_face',
					'Face-Access-Terminal' : 'rule_face',
					actions : 'rule_actions',
					parking : "rule_lpr",                   
				};

                if (this.info_item && this.info_item.id) {
                    url = url  + list_analytic[this.info_item.analytic] + '/' + this.info_item.id;

                    this.$axios.delete(url).then( res => {
                        let idx = this.list.findIndex(x => x && x.id == this.info_item.id);
                        if (idx >= 0) {
                            this.list.splice(idx, 1);
                        }
                        this.total --;
                        if (this.list && this.list.length == 1) {
                            this.total = 1;
                        }
                        this.$Helper.set_local('rule_alarm', this.list);
                        if (this.info_id === 0) {
                            this.list = [];                 
                        }
                        let list_temp = this.list;
                        
                        EventBus.$emit('notifications_modal',{
                            type    : 'deleted',
                            message : 'Rule'
                        });
                        this.$emit('info_component', {
                            act     : 'render_compt',
                            opt     : 'rules',
                            value   : list_temp && list_temp.length > 0 ? list_temp : null,
                        })
                    }).catch(er => {
                        console.log("Error Delete rule : ", er);
                        let err = er && er.message ? er.message : er;
                        EventBus.$emit('notifications_modal', {
                            type    : 'error',
                            message : 'Error delete rule' + err,
                        });
                    })
                }else{
                    // console.log("DELETING ", this.list.indexOf(this.info_item))
                    let idx = this.list.indexOf(this.info_item);
                    if (idx >= 0) {
                            
                        this.list.splice(idx, 1);
                        this.total --;
                        this.$Helper.set_local('rule_alarm', this.list);
                        if (this.info_id === 0) {
                            this.list = [];                 
                        }
                        let list_temp = this.list;
                        
                        EventBus.$emit('notifications_modal',{
                            type    : 'deleted',
                            message : 'Rule'
                        });
                        this.$emit('info_component', {
                            act     : 'render_compt',
                            opt     : 'rules',
                            value   : list_temp && list_temp.length > 0 ? list_temp : null,
                        })
                    }
                }
            }, // delete

            onChange(input) {
                this.input = input;
                this.search= input.toUpperCase();
            },
            onKeyPress(button) {                
                if (button=='{enter}') {
                    this.get_search(this.search);
                }
            },
            onInputChange(input) {
                this.input = input.target.value;
              
            },
            keyboard_is_active(){
                let key_board=false;
                if (localStorage.getItem('virtual_Key_board')) {
                    key_board=JSON.parse(localStorage.getItem('virtual_Key_board'));
                }
            
                if (key_board==true) {
                    this.sheet=true;
            
                }
            
            }, // keyboard  is active

            info_format(item){
                if (item) {
                    console.log("ITEM FORMAT ", item)
                    let info_temp       = item;
                    let analytic        = item && item.analytic ? item.analytic : false ;
                    let info_formated   = {};
                    let heads           = [];
                    let header_temp     = this.header_table;
                    let heads_analytics = this.header_analytics;
                    if (analytic == 'motion') {
                        heads = ['state']                       
                    }
                    if (analytic == 'object') {
                        heads = [
                            'tag',
                            'alertime',
                            'side',
                            'way',
                            'prob',
                            'countag',
                            'state',
                            'speed',
                        ];
                    }
                    if (analytic == 'actions') {
                        heads = [
                            'tag',                          
                            'prob',
                            'state',
                        ];
                    }
                    if (['lpr', 'parking'].includes(analytic)) {
                        heads = [
                            'idList',
                            'direction',
                            'state',
                        ];
                    }
                    if (analytic == 'face') {
                        heads = [
                            'entity',
                            'idList',
                            // 'access',
                            // 'active',
                            'prob',
                            'state' 
                        ]; 
                    }
                    if (analytic == 'Face-Access-Terminal') {
                        heads = [
                            'entity',
                            'idList',
                            // 'access',
                            // 'active',
                            'prob',
                            'state' 
                        ]; 
                    }
                    
                    if (analytic == 'technical') {
                        heads = [
                            'status',
                            'state',
                        ]
                        info_formated.tag = this.$ml.get(info_temp.status)
                        // info_formated.details = 

                    }


                    // for add in header table
                    if (heads && heads.length > 0) {
                        heads.unshift('analytic'); // add firts
                        heads.forEach( (arr_head, idx_head )=> {
                            
                            // formated header 
                            /*if (!heads_analytics.includes(arr_head)) {
                                let temp = { 
                                    text  : arr_head , 
                                    value : arr_head 
                                };
                                heads_analytics.push(arr_head);
                                console.log(header_temp, temp, idx_head, "INSERT HEAD TABLE");                              
                                header_temp.splice(idx_head + 1, 0,  temp);
                            }*/

                            // formated info 
                            info_formated[arr_head] =  info_temp[arr_head]; 
                            if (!info_temp[arr_head] && this.list_default_falses.includes(arr_head)) {
                                info_formated[arr_head] = false;
                            }                       
                        });
                    }
                    // console.log("FORMATED ", info_formated)
                    // console.log("HEADER FORMAT **************** : ", header_temp, info_formated);
                    // this.headers = header_temp;
                    // this.$Helper.set_local('header_rules_alarm', header_temp);
                    // if (this.header_analytics.include()) {}
                    if (info_formated) {

                        return info_formated 
                    }
                    return null
                } // item   
                return null

            }, // info_format

            render_value(item){
                if (item) {                 
                    if (item.value_def  && this.title == 'save' ){
                        this.info[item.key] = item.value_def 
                    }else if (!this.info[item.key]) {
                        this.info[item.key] = item.value_def                        
                    } 
                }

            }, // render value

            async get_list_trained(){
                let page  = 1,
                    pages = 2,
                    list  = []; 

                while (page <= pages){

                    const api = this.$URL + "/api/v1/face/trained/?page=" + page;
                    // '/api/face/list?page='
                    
                    const listed =  await  
                    this.$axios.get(api).then( res => {
                        if (res && res.data && res.data.rows && res.data.rows.length > 0) {

                            let items   =  res.data.rows;
                            // if (res.data.pages > page){ // next
                            // }
                            
                            if (page == 1) {                            
                                list  = items;
                                pages = parseInt(res.data.pages);      
                            }else{
                                list = list.concat(items);
                            }
                        }

                        return list;
                        
                    }).catch( er =>{
                        console.log(er, 'error get list trained')
                    })
                    page++;             
                }
                
                if (list && list.length > 0) {     
                    list.unshift({userId : "all", userName : this.$ml.get("all"), name : "All"}); // faceUUID
                    this.list_entity        = list;
                    this.lists.list_entity  = list;
                }

            }, // get_list_trained

            get_listing(pg = 1){
                
                // const { itemsPerPage, page } = this.options;
                
                let vm      = this;
                const api   = this.$URL + '/api/v1/list/?page=' + pg;
                console.log("get_listing - API:", api);
                // this.loading = true;
                
                this.$axios.get(api).then( res => {
                    console.log("get_listing - response:", res);
                    // console.log(res, 'res get_list');
                    if (res &&  res.data && res.data.rows && res.data.rows.length > 0) {

                        let items       = res.data.rows;
                        console.log("get_listing - items received:", items);
                        // this.total = res.data.count;
                        let temp_list   = [];

                        if (items && items.length > 0) {
                            /*items.forEach((item_list) => {
                                if (item_list && item_list.name && 'lpr' == item_list.type) {
                                    temp_list.push(item_list);
                                }
                            })*/
                            this.lists.list_multi   = this.lists.list_multi.concat(items);// temp_list;
                            this.list_multi         = this.list_multi.concat(items);// temp_list;
                            console.log("get_listing - updated lists.list_multi:", this.lists.list_multi);
                            console.log("get_listing - updated list_multi:", this.list_multi);
                        // console.log(" LISTS : ", temp_list, items)
                        }
                        else{
                            /*this.$EventBus.$emit('notifications_modal', {
                                type    : 'warning',
                                message : ' Required have list created of type lpr : go to lists'
                            })*/
                        }
                        
                            // console.log("pages ", res.data.pages, "  > ", pg );
                        if (parseInt(res.data.pages) > pg) {                            
                            this.get_listing(pg++);
                        }
                        // this.loading = false;
                    }

                }).catch( er => {
                    // this.loading = false;                    
                    console.log(er, 'Error get_list');
                    let err = er && er.message ? er.message : er;
                    this.$EventBus.$emit('notifications_modal',{
                        type    : 'warning',
                        message : 'Failed Get the lists : ' + err
                    })
                })
            }, // get listing

            filter_search(val, list_sel, key){
                let list = [];
                let vn   = this;
                
                list     = vn.lists[list_sel].filter( filter => {
                    return filter[key] && filter[key].toLowerCase().indexOf(val) > -1
                }) 
                this[list_sel] = list;
            }, // filter search

            renderListTecnicals(){
                this.$nextTick(()=>{                    
                    this.listStatusTecnicals.forEach((it)=>{
                        it.name=this.$ml.get(it.code)
                    })
                })
            },

            sortedList(list, check_list) {
                if (!Array.isArray(list)) {
                    return [];
                }
                if (list.length === 0) {
                    return [];
                }
                if (!check_list || !Array.isArray(check_list)) {
                    return list.slice().sort((a, b) => {
                        const nameA = a.name ? a.name.toLowerCase() : '';
                        const nameB = b.name ? b.name.toLowerCase() : '';
                        return nameA.localeCompare(nameB);
                    });
                }
                let filteredList = list.filter(item => {
                    return item && item.type && check_list.includes(item.type);
                });
                return filteredList.sort((a, b) => {
                    const nameA = a.name ? a.name.toLowerCase() : '';
                    const nameB = b.name ? b.name.toLowerCase() : '';
                    return nameA.localeCompare(nameB);
                });
            },

            getListFilter() {
                if (this.info.analytic === 'parking') return ['parking'];
                if (this.info.analytic === 'face') return ['face'];
                if (this.info.analytic === 'lpr') return ['lpr'];
                // Puedes agregar más casos según tus analytics
                return ['lpr', 'parking', 'face'];
            },

        },// methods

        computed:{
            render_list: function(){
                this.total = this.list.length || 0;
                return this.list;
            },

            render_list_multi: function(){
                return this.lists.list_multi;
            },

            // Computed property específico para listas filtradas por tipo
            filtered_lists: function() {
                return {
                    list_multi: this.sortedList(this.lists.list_multi, ['lpr', 'parking', 'face']),
                    list_entity: this.lists.list_entity,
                    listStatusTecnicals: this.listStatusTecnicals
                };
            },

        }, // computed

        mounted(){
            this.renderListTecnicals();
        }, // mounted

        beforeDestroy(){
            this.list = [];
        }, // beforeDestroy
    };
</script>
